export const darkThemeHostConfig: any = {
  'containerStyles': {
    'default': {
      'foregroundColors': {
        'default': {
          'default': '#FFFFFF',
          'subtle': '#88FFFFFF',
          'highlightColors': {
            'default': '#22000000',
            'subtle': '#11000000'
          }
        },
        'dark': {
          'default': '#000000',
          'subtle': '#66000000',
          'highlightColors': {
            'default': '#22000000',
            'subtle': '#11000000'
          }
        },
        'light': {
          'default': '#FFFFFF',
          'subtle': '#33000000',
          'highlightColors': {
            'default': '#22000000',
            'subtle': '#11000000'
          }
        },
        'accent': {
          'default': '#2E89FC',
          'subtle': '#882E89FC',
          'highlightColors': {
            'default': '#22000000',
            'subtle': '#11000000'
          }
        },
        'good': {
          'default': '#00FF00',
          'subtle': '#DD00FF00',
          'highlightColors': {
            'default': '#22000000',
            'subtle': '#11000000'
          }
        },
        'warning': {
          'default': '#FFD800',
          'subtle': '#DDFFD800',
          'highlightColors': {
            'default': '#22000000',
            'subtle': '#11000000'
          }
        },
        'attention': {
          'default': '#FF0000',
          'subtle': '#DDFF0000',
          'highlightColors': {
            'default': '#22000000',
            'subtle': '#11000000'
          }
        }
      },
      'backgroundColor': '#1F1F1F'
    },
    'emphasis': {
      'foregroundColors': {
        'default': {
          'default': '#FFFFFF',
          'subtle': '#88FFFFFF',
          'highlightColors': {
            'default': '#22000000',
            'subtle': '#11000000'
          }
        },
        'dark': {
          'default': '#000000',
          'subtle': '#66000000',
          'highlightColors': {
            'default': '#22000000',
            'subtle': '#11000000'
          }
        },
        'light': {
          'default': '#FFFFFF',
          'subtle': '#33000000',
          'highlightColors': {
            'default': '#22000000',
            'subtle': '#11000000'
          }
        },
        'accent': {
          'default': '#2E89FC',
          'subtle': '#882E89FC',
          'highlightColors': {
            'default': '#22000000',
            'subtle': '#11000000'
          }
        },
        'good': {
          'default': '#00FF00',
          'subtle': '#DD00FF00',
          'highlightColors': {
            'default': '#22000000',
            'subtle': '#11000000'
          }
        },
        'warning': {
          'default': '#FF0000',
          'subtle': '#DDFF0000',
          'highlightColors': {
            'default': '#22000000',
            'subtle': '#11000000'
          }
        },
        'attention': {
          'default': '#FFD800',
          'subtle': '#DDFFD800',
          'highlightColors': {
            'default': '#22000000',
            'subtle': '#11000000'
          }
        }
      },
      'backgroundColor': '#19FFFFFF'
    }
  }
};

export const lightThemeHostConfig: any = {
  'containerStyles': {
    'default': {
      'foregroundColors': {
        'default': {
          'default': '#000000',
          'subtle': '#767676',
          'highlightColors': {
            'default': '#22000000',
            'subtle': '#11000000'
          }
        },
        'dark': {
          'default': '#000000',
          'subtle': '#66000000',
          'highlightColors': {
            'default': '#22000000',
            'subtle': '#11000000'
          }
        },
        'light': {
          'default': '#FFFFFF',
          'subtle': '#33000000',
          'highlightColors': {
            'default': '#22000000',
            'subtle': '#11000000'
          }
        },
        'accent': {
          'default': '#0063B1',
          'subtle': '#0063B1',
          'highlightColors': {
            'default': '#22000000',
            'subtle': '#11000000'
          }
        },
        'good': {
          'default': '#54a254',
          'subtle': '#DD54a254',
          'highlightColors': {
            'default': '#22000000',
            'subtle': '#11000000'
          }
        },
        'warning': {
          'default': '#c3ab23',
          'subtle': '#DDc3ab23',
          'highlightColors': {
            'default': '#22000000',
            'subtle': '#11000000'
          }
        },
        'attention': {
          'default': '#FF0000',
          'subtle': '#DDFF0000',
          'highlightColors': {
            'default': '#22000000',
            'subtle': '#11000000'
          }
        }
      },
      'backgroundColor': '#FFFFFF'
    },
    'emphasis': {
      'foregroundColors': {
        'default': {
          'default': '#000000',
          'subtle': '#767676',
          'highlightColors': {
            'default': '#22000000',
            'subtle': '#11000000'
          }
        },
        'dark': {
          'default': '#000000',
          'subtle': '#66000000',
          'highlightColors': {
            'default': '#22000000',
            'subtle': '#11000000'
          }
        },
        'light': {
          'default': '#FFFFFF',
          'subtle': '#33000000',
          'highlightColors': {
            'default': '#22000000',
            'subtle': '#11000000'
          }
        },
        'accent': {
          'default': '#2E89FC',
          'subtle': '#882E89FC',
          'highlightColors': {
            'default': '#22000000',
            'subtle': '#11000000'
          }
        },
        'good': {
          'default': '#54a254',
          'subtle': '#DD54a254',
          'highlightColors': {
            'default': '#22000000',
            'subtle': '#11000000'
          }
        },
        'warning': {
          'default': '#c3ab23',
          'subtle': '#DDc3ab23',
          'highlightColors': {
            'default': '#22000000',
            'subtle': '#11000000'
          }
        },
        'attention': {
          'default': '#FF0000',
          'subtle': '#DDFF0000',
          'highlightColors': {
            'default': '#22000000',
            'subtle': '#11000000'
          }
        }
      },
      'backgroundColor': '#F0F0F0'
    }
  }
};